<template>
  <div class="ui form">
    <div class="field">
      <label for="">{{ $t("legals") }}</label>
      <textarea name="" rows="2" v-model="setup.legals"></textarea>
    </div>
    <div class="field">
      <label for="">{{ $t("terms and conditions link") }}</label>
      <input type="text" name="" v-model="setup.terms" />
    </div>
    <wysywyg v-model="setup.page" :show_css="false" :show_js="false" />
  </div>
</template>

<script>
import {
  /* local_api, error_toast, */ enterprise_setup,
  // api_host,
} from "@/utils";
import Wysywyg from "@/components/Wysywyg/Wysywyg";
import filters from "@/filters";

export default {
  name: "NvidiaBundleStoreModalGeneral",
  filters: filters,
  components: { Wysywyg },
  computed: {
    form() {
      let vm = this;
      return window.jQuery(vm.$refs.form).form({
        fields: {
          name: ["empty"],
          country: ["empty"],
        },
      });
    },
    token_session() {
      let token = this.$session.get("token");
      return token;
    },
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  props: {
    setup: Object,
  },
  data() {
    return {
      // setup: { page: { html: "", css: "", js: "" } },
    };
  },
  methods: {
    setData(setup) {
      // let vm = this;
      // vm.setup = setup;
      // console.log(setup);
      this.logo = setup.logo;
    },
    getData() {
      return this.logo;
    },
    isValid() {
      return this.form.form("validate form");
    },
  },
  mounted() {},
  watch: {},
  updated: function() {},
};
</script>
